// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class StopListRequests {
    /**
     * @returns {Promise<StopListInitDataResponse>}
     */
    async GetInitData() {
        return await SmrClient.FetchJson({
            url: 'StopList/GetInitData',
            method: 'GET'
        });
    }

    /**
     * @param {StopListFilterSet} filters 
     * @returns {Promise<WebRecords<WebStopListItem>>}
     */
    async GetData(filters) {
        return await SmrClient.FetchJson({
            url: 'StopList/GetData',
            method: 'POST',
            body: filters
        });
    }

    /**
     * @param {number[]} ids
     */
    async Retry(ids) {
        await SmrClient.FetchJson({
            url: 'StopList/Retry',
            method: 'POST',
            body: ids
        });
    }

    /**
     * @param {number[]} ids
     */
    async Cancel(ids) {
        await SmrClient.FetchJson({
            url: 'StopList/Cancel',
            method: 'POST',
            body: ids
        });
    }

    /**
     * @param {number} entityId
     */
    async PrintStoplistEntity(entityId) {
        await SmrClient.FetchDownload({
            url: 'StopList/PrintStoplistEntity',
            method: 'POST',
            body: { entityId: entityId },
            bodyIsUrlParams: true
        });
    }
}

export default new StopListRequests;